import React, { useMemo } from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { ClockNineIcon, FireIcon, ParentUserIcon } from '@cp/ds/src/icons/career/properties/nannies';
import { SvgIconComponent } from '@cp/ds';
import { styled } from '@cp/ui';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { formatResponseDelay } from '../../../model';

interface ResumeCardStatsProps {
  data: CatalogItemViewModel;
  fontSize?: 'small' | 'medium' | 'large';
}

const Root = styled(Stack)(({ theme }) => ({
  padding: '6px 20px',
  borderTop: `1px solid ${theme.palette.divider}`,
  width: '100%',
  height: '60px',
  [theme.breakpoints.down('md')]: {
    borderTop: 'none',
    padding: '6px',
    maxWidth: '90px',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));

export const ResumeCardStatsNew: React.FC<ResumeCardStatsProps> = ({ data, fontSize = 'large' }) => {
  const responseDelay = useMemo(() => formatResponseDelay(data.responseDelay), [data.responseDelay]);

  const itemData = [
    { icon: FireIcon, state: data.reviewsCount + 1, label: 'заказов выполнено' },
    { icon: ClockNineIcon, state: data.experience && data.experience * 150 * 3, label: 'часов с детьми' },
    { icon: ParentUserIcon, state: data.reviewsCount, label: 'родителей вернулись' },
    { state: responseDelay[0], label: 'скорость ответа' },
  ];

  const renderItem = (label: string, value: React.ReactNode, icon?: SvgIconComponent) => {
    const Icon = icon;
    return (
      <Root alignItems="center" direction={{ xs: 'column', md: 'row' }}>
        <Stack alignItems="flex-end" direction="row" gap={0.2} sx={{ width: { md: '110px' }, pl: !Icon ? '5px' : 0 }}>
          {Icon ? <Icon fontSize={fontSize} /> : null}
          <Typography component="span" sx={{ fontSize: { xs: '20px', md: '24px' }, lineHeight: 1.2 }} variant="h5">
            {value}
          </Typography>
          {!Icon && (
            <Typography component="span" sx={{ lineHeight: { md: 1.7 } }} variant="caption bold">
              {responseDelay[1]}
            </Typography>
          )}
        </Stack>
        <Typography component="span" sx={{ color: 'grey', fontSize: { xs: '12px', md: '14px' } }} variant="caption bold">
          {label}
        </Typography>
      </Root>
    );
  };

  return (
    <>
      {itemData.map((item, index) => (
        <React.Fragment key={index}>{renderItem(item.label, item.state, item.icon)}</React.Fragment>
      ))}
    </>
  );
};
